<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { getLocalStorageItem } from '../../utility.js';

    export let questions;
    export let subcategoryID;
    let selected = [];
    let questionID;
    let answers = {};
    const dispatch = createEventDispatcher();

    function handleChoiceSelection(choice) {
        if (selected.includes(choice)) {
            // If the value is already selected, remove it from the answers array
            selected = selected.filter(item => item !== choice);
        } else {
            // since the value has not been selected yet, add it to the answers array
            selected = [...selected, choice];
        }
        dispatchAnswerChange();
    }
    
    function loadSavedAnswers() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        const answerString = questionnaireAnswers[subcategoryID]?.[questionID];
        if (answerString) {
            try {
                selected = JSON.parse(answerString);
            } catch (error) {
                console.error('Error parsing JSON:', error);
            }
        }
        dispatchAnswerChange();
    }

    function dispatchAnswerChange() {
        answers = { [questionID] : JSON.stringify(selected) };
        dispatch('answerChange', { answers });
    }

    onMount(async () => {
        questionID = questions[0].question_id;
        selected = [];
        loadSavedAnswers();
    });

</script>

{#if questions}
    <ul class="text-secondary-text">
        {#each JSON.parse(questions[0].question_text.replaceAll("'", '"')) as choice}
            <li class="flex items-center ps-3">
                <input type="checkbox" checked={selected.includes(choice)} value={choice} id={choice} on:click={() => {handleChoiceSelection(choice)}} class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
                <label for={choice} class="py-1 ms-2">{choice}</label>
            </li>
        {/each}
    </ul>
{:else}
    <div>Loading...</div>
{/if}
